export default __webpack_public_path__ + "static/media/Taras280.9253b794.jpg";